export default "__VITE_ASSET__6ro3ajWr__"